module.exports = __webpack_public_path__ + "assets/img/37-l.6e66c83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/37-l.jpg
// module id = Iw74
// module chunks = 0